"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
const sizerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};
class AutosizeInput extends _react.default.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      inputWidth: this.props.minWidth
    };
    this.inputRef = el => {
      this.input = el;
    };
    this.placeHolderSizerRef = el => {
      this.placeHolderSizer = el;
    };
    this.sizerRef = el => {
      this.sizer = el;
    };
    this.copyInputStyles = () => {
      if (this.mounted || !window.getComputedStyle) {
        return;
      }
      const inputStyle = this.input && window.getComputedStyle(this.input);
      if (!inputStyle) {
        return;
      }
      const widthNode = this.sizer;
      widthNode.style.fontSize = inputStyle.fontSize;
      widthNode.style.fontFamily = inputStyle.fontFamily;
      widthNode.style.fontWeight = inputStyle.fontWeight;
      widthNode.style.fontStyle = inputStyle.fontStyle;
      widthNode.style.letterSpacing = inputStyle.letterSpacing;
      widthNode.style.textTransform = inputStyle.textTransform;
      if (this.props.placeholder) {
        const placeholderNode = this.placeHolderSizer;
        placeholderNode.style.fontSize = inputStyle.fontSize;
        placeholderNode.style.fontFamily = inputStyle.fontFamily;
        placeholderNode.style.fontWeight = inputStyle.fontWeight;
        placeholderNode.style.fontStyle = inputStyle.fontStyle;
        placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
        placeholderNode.style.textTransform = inputStyle.textTransform;
      }
    };
    this.updateInputWidth = () => {
      if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
        return;
      }
      let newInputWidth;
      if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
        newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
      } else {
        newInputWidth = this.sizer.scrollWidth + 2;
      }
      if (newInputWidth < this.props.minWidth) {
        newInputWidth = this.props.minWidth;
      }
      if (newInputWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    };
    this.getInput = () => {
      return this.input;
    };
    this.focus = () => {
      this.input.focus();
    };
    this.blur = () => {
      this.input.blur();
    };
    this.select = () => {
      this.input.select();
    };
  }
  componentDidMount() {
    this.mounted = true;
    this.copyInputStyles();
    this.updateInputWidth();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.inputWidth !== this.state.inputWidth) {
      if (typeof this.props.onAutosize === 'function') {
        this.props.onAutosize(this.state.inputWidth);
      }
    }
    this.updateInputWidth();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
      if (previousValue !== null && previousValue !== undefined) {
        return previousValue;
      }
      return currentValue;
    });
    const wrapperStyle = this.props.style || {};
    if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
    const inputStyle = Object.assign({}, this.props.inputStyle);
    inputStyle.width = this.state.inputWidth + 'px';
    inputStyle.boxSizing = 'content-box';
    const inputProps = Object.assign({}, this.props);
    inputProps.className = this.props.inputClassName;
    inputProps.style = inputStyle;
    // ensure props meant for `AutosizeInput` don't end up on the `input`
    delete inputProps.inputClassName;
    delete inputProps.inputStyle;
    delete inputProps.minWidth;
    delete inputProps.onAutosize;
    delete inputProps.placeholderIsMinWidth;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: this.props.className,
      style: wrapperStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", Object.assign({}, inputProps, {
        ref: this.inputRef
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: this.sizerRef,
        style: sizerStyle,
        children: sizerValue
      }), this.props.placeholder ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: this.placeHolderSizerRef,
        style: sizerStyle,
        children: this.props.placeholder
      }) : null]
    });
  }
}
AutosizeInput.propTypes = {
  className: _propTypes.default.string,
  // className for the outer element
  defaultValue: _propTypes.default.any,
  // default field value
  inputClassName: _propTypes.default.string,
  // className for the input element
  inputStyle: _propTypes.default.object,
  // css styles for the input element
  minWidth: _propTypes.default.oneOfType([
  // minimum width for input element
  _propTypes.default.number, _propTypes.default.string]),
  onAutosize: _propTypes.default.func,
  // onAutosize handler: function(newWidth) {}
  onChange: _propTypes.default.func,
  // onChange handler: function(newValue) {}
  placeholder: _propTypes.default.string,
  // placeholder text
  placeholderIsMinWidth: _propTypes.default.bool,
  // don't collapse size to less than the placeholder
  style: _propTypes.default.object,
  // css styles for the outer element
  value: _propTypes.default.any // field value
};
AutosizeInput.defaultProps = {
  minWidth: 1
};
var _default = exports.default = AutosizeInput;
module.exports = exports.default;